import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonLoading,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Paper,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { requestID, baseUrl, config } from "../../../common/utils";

const FundCustomerWallet: React.FC = () => {
  const [historyTable, setHistoryTable] = useState([]);
  const [status, setStatus] = useState({
    loading: false,
    error: false,
    message: "",
  });

  // Filter states
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [batchSize, setBatchSize] = useState("200");
  const [currentBatch, setCurrentBatch] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [hasMoreRecords, setHasMoreRecords] = useState(false);

  // Pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [offsetx, setOffsetx] = useState(0);
  // Function to generate report with batch parameters
  async function generateReport(batchIndex = 0) {
    if (!filterStartDate || !filterEndDate) {
      alert("Please select both start and end dates");
      return;
    }

    setStatus({ loading: true, error: false, message: "Generating report..." });
    setCurrentBatch(batchIndex);

    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("startDate", filterStartDate);
      formData.append("endDate", filterEndDate);
      formData.append("limit", batchSize);
      formData.append("offset", (batchIndex * parseInt(batchSize)).toString());
      console.log("API Call Parameters:", {
        startDate: filterStartDate,
        endDate: filterEndDate,
        limit: batchSize,
        offset: batchIndex * parseInt(batchSize)
      });

      const response = await axios.post(
        baseUrl() + "wallets/latestTransactions_batched",
        formData,
        config
      );

      console.log("Report response:", response);
      
      // Assuming the API returns data and total count
      const data = response.data.data || response.data || [];
      const totalCount = response.data.totalCount || response.data.total || 0;
      setOffsetx((parseInt(totalCount)));

      setHistoryTable(data);
      setTotalRecords(totalCount);
      
      // Check if there are more records
      const batchCount = parseInt(batchSize);
      const totalFetched = (batchIndex + 1) * batchCount;
      const moreRecordsAvailable = totalFetched < totalCount;
      
      console.log("Batch calculation:", {
        batchIndex,
        batchSize: batchCount,
        totalFetched,
        totalCount,
        hasMore: moreRecordsAvailable
      });
      
      setHasMoreRecords(moreRecordsAvailable);
      setPage(0); // Reset to first page when changing batch

      setStatus({ loading: false, error: false, message: "" });
    } catch (error) {
      console.error("Error generating report:", error);
      setStatus({ loading: false, error: true, message: "Failed to generate report" });
    }
  }



 async function loadNextBatchNext(batchIndex) {
    if (!filterStartDate || !filterEndDate) {
      alert("Please select both start and end dates");
      return;
    }

    setStatus({ loading: true, error: false, message: "Generating report..." });
    setCurrentBatch(batchIndex);

    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("startDate", filterStartDate);
      formData.append("endDate", filterEndDate);
      formData.append("offset", offsetx.toString());
//setOffsetx(offsetx + parseInt(batchSize));


      console.log("API Call Parameters:", {
        startDate: filterStartDate,
        endDate: filterEndDate,
        limit: batchSize,
        offset: batchIndex * parseInt(batchSize)
      });


      console.log("API Call Parameters:", {
        startDate: filterStartDate,
        endDate: filterEndDate,
        limit: batchSize,
        offset: batchIndex * parseInt(batchSize)
      });

      const response = await axios.post(
        baseUrl() + "wallets/latestTransactions_batched_next",
        formData,
        config
      );

      console.log("Report response:", response);
      
      // Assuming the API returns data and total count
      const data = response.data.data || response.data || [];
      const totalCount = response.data.totalCount || response.data.total || 0;
            setOffsetx(offsetx + totalCount);

      setHistoryTable(data);
      setTotalRecords(totalCount);
      
      // Check if there are more records
      const batchCount = parseInt(batchSize);
      const totalFetched = (batchIndex + 1) * batchCount;
      const moreRecordsAvailable = totalFetched < totalCount;
      
      console.log("Batch calculation:", {
        batchIndex,
        batchSize: batchCount,
        totalFetched,
        totalCount,
        hasMore: moreRecordsAvailable
      });
      
      setHasMoreRecords(moreRecordsAvailable);
      setPage(0); // Reset to first page when changing batch

      setStatus({ loading: false, error: false, message: "" });
    } catch (error) {
      console.error("Error generating report:", error);
      setStatus({ loading: false, error: true, message: "Failed to generate report" });
    }
  }
  // Function to load next batch
  const loadNextBatch = () => {
    generateReport(currentBatch + 1);
  };

  // Function to load previous batch
  const loadPreviousBatch = () => {
    if (currentBatch > 0) {
      generateReport(currentBatch - 1);
    }
  };

  // Calculate the current items to display in the table
  // const currentTableData = historyTable?.slice(
  //   page * rowsPerPage,
  //   page * rowsPerPage + rowsPerPage
  // );
const currentTableData = historyTable;
  ;
  // Helper function to calculate display range
  const getDisplayRange = () => {
    const batchSizeNum = parseInt(batchSize);
    const startRecord = 0 ; //currentBatch * batchSizeNum + 1;
    const endRecord = batchSizeNum ;  Math.min((currentBatch + 1) * batchSizeNum, totalRecords);

    // console.log("Display Range Calculation:", {
    //   currentBatch,
    //   startRecord,
    //   endRecord
    // });
    //return { startRecord, endRecord };
     return { startRecord, endRecord };

  };

  const { startRecord, endRecord } = getDisplayRange();

  return (
    <IonPage  >
      <IonHeader className="ion-padding">
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Customer Wallet Fund Report</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        {/* Report Generation Controls */}
        <Paper style={{ padding: "24px", margin: "16px" }}>
          <Typography variant="h6" gutterBottom>
            Generate Report
          </Typography>
          <Box
            component="form"
            noValidate
            sx={{ display: "flex", gap: 2, flexWrap: "wrap", alignItems: "flex-end" }}
          >
            <TextField
              label="Start Date"
              type="date"
              variant="outlined"
              value={filterStartDate}
              onChange={(e) => setFilterStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ flex: "1 1 180px" }}
              required
            />
            <TextField
              label="End Date"
              type="date"
              variant="outlined"
              value={filterEndDate}
              onChange={(e) => setFilterEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={{ flex: "1 1 180px" }}
              required
            />
            <FormControl sx={{ flex: "1 1 150px" }}>
              <InputLabel>Records per Batch</InputLabel>
              <Select
                value={batchSize}
                label="Records per Batch"
                onChange={(e) => setBatchSize(e.target.value)}
              >
                <MenuItem value="100">100 records</MenuItem>
                <MenuItem value="200">200 records</MenuItem>
                <MenuItem value="500">500 records</MenuItem>
              </Select>
            </FormControl>
            
            <Box sx={{ display: "flex", gap: 1, flex: "1 1 100%", mt: 2 }}>
              <IonButton 
                onClick={() => generateReport(0)}
                disabled={!filterStartDate || !filterEndDate}
                style={{ flex: 1 }}
              >
                Generate First Batch
              </IonButton>
              
              {currentBatch > 0 && (
                <IonButton 
                  onClick={loadPreviousBatch}
                  fill="outline"
                  style={{ flex: 1 }}
                >
                  ← Previous Batch
                </IonButton>
              )}
              
              {hasMoreRecords && (
                <IonButton 
                  onClick={loadNextBatchNext}
                  fill="outline"
                  style={{ flex: 1 }}
                >
                  Next  Batch →
                </IonButton>
              )}
            </Box>
          </Box>

          {/* Batch Information */}
        
        </Paper>

        {/* Results Section */}
        {historyTable.length > 0 && (
          <>
            <IonTitle
              style={{
                color: "#1976d2",
                textAlign: "center",
                padding: "20px 0",
                textTransform: "uppercase",
              }}
            >
              Transaction Report - 
              {/* Batch {currentBatch + 1} */}
            </IonTitle>

            <Paper
              style={{
                backgroundColor: "white",
                color: "#333",
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                border: "1px solid #e0e0e0",
                margin: "0 16px 40px",
              }}
            >

                  {historyTable.length > rowsPerPage && (
                <Box sx={{ p: 2, borderTop: "1px solid #e0e0e0" }}>
                  {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Page {page + 1} of {Math.ceil(historyTable.length / rowsPerPage)} 
                    (showing {rowsPerPage} rows per page within current batch)
                  </Typography> */}
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {/* <IonButton 
                      onClick={() => setPage(prev => Math.max(0, prev - 1))}
                      disabled={page === 0}
                      fill="outline"
                      size="small"
                    >
                      ← Previous Page
                    </IonButton> */}
                    <Typography variant="body2">
                      Showing {page * rowsPerPage + 1} of {historyTable.length} records in batch
                    </Typography>
                    <IonButton 
                      onClick={() => 
                        // setPage(prev => prev + 1)
loadNextBatchNext()

                      }
                      // disabled={(page + 1) * rowsPerPage >= historyTable.length}
                      fill="outline"
                      size="small"
                    >
                      Next Page →
                    </IonButton>
                  </Box>
                </Box>
              )}
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: "#1976d2" }}>

                      <TableCell style={{ color: "white", textAlign: "center" }}>
                      Id No.
                    </TableCell>
                    <TableCell style={{ color: "white", textAlign: "center" }}>
                      Full Name
                    </TableCell>
                    <TableCell style={{ color: "white", textAlign: "center" }}>
                      Email/Phone
                    </TableCell>
                    <TableCell style={{ color: "white", textAlign: "center" }}>
                      Staff Name
                    </TableCell>
                    <TableCell style={{ color: "white", textAlign: "center" }}>
                      Credited Amount (₦)
                    </TableCell>
                    <TableCell style={{ color: "white", textAlign: "center" }}>
                      Method of Payment
                    </TableCell>
                    <TableCell style={{ color: "white", textAlign: "center" }}>
                      Date
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentTableData?.map((row: any, i: number) => (
                    <TableRow
                      key={i}
                      style={{ backgroundColor: i % 2 ? "#f9f9f9" : "white" }}
                    >
                        <TableCell style={{ textAlign: "center" }}>
                        {row.id || 'N/A'}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {row.firstName + ' ' + (row.middleName || '') + ' ' + row.lastName} 
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {row.email || row.phone || 'N/A'}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {row.staff_name || 'N/A'}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        ₦{new Intl.NumberFormat("en-NG").format(row.drValue || 0)}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {row.shopID || row.paymentMethod || 'N/A'}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        {row.dateCreated || 'N/A'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              
              {/* Pagination within current batch */}
              {/* {historyTable.length > rowsPerPage && (
                <Box sx={{ p: 2, borderTop: "1px solid #e0e0e0" }}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Page {page + 1} of {Math.ceil(historyTable.length / rowsPerPage)} 
                    (showing {rowsPerPage} rows per page within current batch)
                  </Typography>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <IonButton 
                      onClick={() => setPage(prev => Math.max(0, prev - 1))}
                      disabled={page === 0}
                      fill="outline"
                      size="small"
                    >
                      ← Previous Page
                    </IonButton>
                    <Typography variant="body2">
                      Showing {page * rowsPerPage + 1} of {historyTable.length} records in batch
                    </Typography>
                    <IonButton 
                      onClick={() => 
                        // setPage(prev => prev + 1)
loadNextBatchNext()

                      }
                      // disabled={(page + 1) * rowsPerPage >= historyTable.length}
                      fill="outline"
                      size="small"
                    >
                      Next Page →
                    </IonButton>
                  </Box>
                </Box>
              )} */}
            </Paper>
          </>
        )}

        {/* Debug information in console */}
        {historyTable.length > 0 && (
          <Box sx={{ display: 'none' }}>
            {/* This is just to trigger console logs */}
            {console.log("Current State:", {
              batchSize,
              currentBatch,
              totalRecords,
              hasMoreRecords,
              offset: currentBatch * parseInt(batchSize),
              historyTableLength: historyTable.length
            })}
          </Box>
        )}

        <IonLoading
          isOpen={status.loading}
          message={status.message || "Please wait..."}
          spinner="circles"
        />
      </IonContent>
    </IonPage>
  );
};

export default FundCustomerWallet;